(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/assets/utils/utils.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/assets/utils/utils.js');
"use strict";


const productName = 'lyckoplatsen';
const isMobile = svs.core.config.data.svsconfig.isNativeApp || svs.core.detect.formfactor.mobile();

const clearWagerStorageAndNavigateToProlong = _ref => {
  let wagerId = _ref.wagerId;
  svs.components.Storage.browser.remove("charity-".concat(wagerId), productName);
  svs.components.Storage.browser.remove("numberOfWeeks-".concat(wagerId), productName);
  svs.components.Storage.browser.remove("lyckoplatsenName-".concat(wagerId), productName);
  svs.components.Storage.browser.remove("pinLocationType-".concat(wagerId), productName);
  svs.components.Storage.browser.remove("locationConfirmed-".concat(wagerId), productName);
  svs.components.Storage.browser.remove("pinLocation-".concat(wagerId), productName);
  svs.utils.url.navigate("/lyckoplatsen/forlang-mina-spel/".concat(wagerId));
};
const LYCKOPLATSEN_CONSTANTS = {
  LOCATION_NAME_DEFAULT: 'Min lyckoplats',
  LOCATION_NAME_MOBILE: 'Min lyckoplats❤️'
};
function getDefaultLocationName() {
  return isMobile ? LYCKOPLATSEN_CONSTANTS.LOCATION_NAME_MOBILE : LYCKOPLATSEN_CONSTANTS.LOCATION_NAME_DEFAULT;
}
function isDefaultLocationName(name) {
  return name === LYCKOPLATSEN_CONSTANTS.LOCATION_NAME_MOBILE || name === LYCKOPLATSEN_CONSTANTS.LOCATION_NAME_DEFAULT;
}
setGlobal('svs.tur.lyckoplatsen.utils', {
  clearWagerStorageAndNavigateToProlong,
  LYCKOPLATSEN_CONSTANTS,
  getDefaultLocationName,
  isDefaultLocationName
});

 })(window);